export default __webpack_public_path__ + "static/scale-up-8a071198bf62a2adefaca8f94526d6ed.png";